export var oneDriveBusinessUrlRegex = /http[s]?:\/\/[\S]*?-my\.sharepoint[\S]*?\.com/;
export var sharePointUrlRegex = /http[s]?:\/\/[\S]*?\.sharepoint[\S]*?\.com/;
export var oneDriveConsumerUrlRegex = /http[s]?:\/\/d\.docs\.live\.net/;
//# sourceMappingURL=constants.js.map